"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, } from "@gsb-core/react-components";
import { useHotkeys } from "../hooks/use-hotkeys";
import { Kbd } from "./kbd";
const DEFAULT_GROUPS = [
    {
        title: "Global",
        shortcuts: [
            { combo: "mod+k", description: "Open the command palette" },
            { combo: "shift+?", description: "Show keyboard shortcuts" },
            { combo: "escape", description: "Close the topmost overlay" },
        ],
    },
    {
        title: "Data",
        shortcuts: [
            { combo: "mod+enter", description: "Run the current query" },
            { combo: "mod+s", description: "Save changes" },
            { combo: "mod+shift+f", description: "Focus the filter bar" },
        ],
    },
];
export function KeyboardShortcutsDialog({ groups = DEFAULT_GROUPS, }) {
    const [open, setOpen] = useState(false);
    const focusReturnRef = useRef(null);
    useHotkeys([{ combo: "shift+?", handler: () => setOpen(true) }]);
    return (_jsx(Dialog, { open: open, onOpenChange: setOpen, children: _jsxs(DialogContent, { className: "max-w-lg", onOpenAutoFocus: () => {
                focusReturnRef.current =
                    document.activeElement instanceof HTMLElement
                        ? document.activeElement
                        : null;
            }, onCloseAutoFocus: (event) => {
                const invoker = focusReturnRef.current;
                focusReturnRef.current = null;
                const target = invoker?.isConnected
                    ? invoker
                    : document.querySelector("main[tabindex]");
                if (!target)
                    return;
                event.preventDefault();
                target.focus({ preventScroll: true });
            }, children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: "Keyboard shortcuts" }), _jsx(DialogDescription, { children: "Every primary action has a keyboard path." })] }), _jsx("div", { className: "flex flex-col gap-5", children: groups.map((group) => (_jsxs("section", { children: [_jsx("h3", { className: "pb-2 text-caption font-semibold uppercase tracking-wider text-content-tertiary", children: group.title }), _jsx("ul", { className: "grid gap-1.5", children: group.shortcuts.map((shortcut) => (_jsxs("li", { className: "flex items-center justify-between gap-4 text-body-sm", children: [_jsx("span", { className: "text-content-secondary", children: shortcut.description }), _jsx(Kbd, { combo: shortcut.combo })] }, shortcut.combo))) })] }, group.title))) })] }) }));
}
//# sourceMappingURL=keyboard-shortcuts-dialog.js.map